<template>
	<div id="sign-success-xp">
		<img class="logo" :src="httpImg +`/invitation-xp/logo-xp4.png`">
		<!-- <h1 class="name">金果子</h1> -->
		<h1 class="title">XP</h1>
		<p>{{ $t('sign.regist_success') }}</p>

		<div class="down-btn" @click="goDown">
			{{ $t('sign.down_app') }}
			<!-- <img class="gift" src="@/assets/invitation-down/gift.png" alt=""> -->
			<!-- <span class="gift-title">快下载领取积分奖励吧</span> -->
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';

	export default {
		name: 'SignSuccess',
		data() {
			return {}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		methods: {
			goDown() {
				//跳转下载页
				this.$router.push({
					name: 'Download-xp',
				})
			}
		}
	}
</script>

<style lang='less'>
	#sign-success-xp {
		height: 100vh;
		position: relative;
		background: #ffffff;
		padding: 120px 60px 0 60px;

		.logo {
			height: 100px;
			width: 100px;
			margin-bottom: 24px;
		}

		h1 {
			line-height: 70px;
			font-size: 48px;
			font-weight: bold;
			color: #1E2329;
			margin-bottom: 120px;
		}

		p {
			color: #1E2329;
			font-size: 36px;
			font-weight: bold;
		}

		.down-btn {
			font-size: 28px;
			height: 88px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			background: #1E2329;
			border-radius: 16px;
			margin: 80px 64px 0 64px;
		}
	}
</style>